import api from "./api";
import type {
  Book,
  CollectionCreate,
  EntryOrganizationUpdate,
  LibraryCollection,
  LibraryTag,
  TagCreate,
} from "../types";
import { conditionalHeaders } from "./concurrency";

export const libraryOrganizationService = {
  async listCollections(signal?: AbortSignal): Promise<LibraryCollection[]> {
    return (await api.get<LibraryCollection[]>("/library/collections", { signal }))
      .data;
  },
  async createCollection(payload: CollectionCreate): Promise<LibraryCollection> {
    return (await api.post<LibraryCollection>("/library/collections", payload)).data;
  },
  async deleteCollection(id: number, updatedAt?: string): Promise<void> {
    await api.delete(`/library/collections/${id}`, {
      headers: conditionalHeaders(updatedAt),
    });
  },
  async listTags(signal?: AbortSignal): Promise<LibraryTag[]> {
    return (await api.get<LibraryTag[]>("/library/tags", { signal })).data;
  },
  async createTag(payload: TagCreate): Promise<LibraryTag> {
    return (await api.post<LibraryTag>("/library/tags", payload)).data;
  },
  async deleteTag(id: number, updatedAt?: string): Promise<void> {
    await api.delete(`/library/tags/${id}`, {
      headers: conditionalHeaders(updatedAt),
    });
  },
  async updateEntry(
    id: number,
    payload: EntryOrganizationUpdate,
    updatedAt?: string
  ): Promise<Book> {
    return (
      await api.put<Book>(`/books/${id}/organization`, payload, {
        headers: conditionalHeaders(updatedAt),
      })
    ).data;
  },
};
